

export default {
  name: "الملف الشخصي",
  update: "تعديل الملف الشخصي",
  photo: "صورة الملف الشخصي",
  account_information: "بيانات الحساب",
  personal_information: "البيانات الشخصية",
}
